/**
 * Extrae el mensaje de error que devuelve la API.
 *
 * Prioriza el detalle de validación (422 de Laravel: errors.campo[0]) sobre el message
 * general, porque el detalle es el que explica al usuario qué hacer. Si la respuesta no
 * trae nada aprovechable — error de red, 500 sin cuerpo — cae en el texto de respaldo.
 *
 * @param {unknown} error Error capturado (típicamente de axios)
 * @param {string} fallback Texto a mostrar si la API no informó nada
 * @returns {string}
 */
export function getApiErrorMessage(error, fallback = 'Ocurrió un error inesperado.') {
  const data = error?.response?.data;

  if (!data) return fallback;

  if (data.errors && typeof data.errors === 'object') {
    const firstDetail = Object.values(data.errors)
      .flat()
      .find((message) => typeof message === 'string' && message.trim() !== '');

    if (firstDetail) return firstDetail;
  }

  return typeof data.message === 'string' && data.message.trim() !== ''
    ? data.message
    : fallback;
}
